<template>
  <div class="nx-relation-form-wrapper">
    <nx-relation-editor
      ref="form"
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      :relation-type="computedRelationType"
      :title="label"
      :name="name"
      :types="types"
      :value="value"
      :disabled="disabled"
      :error-messages="errorMessages"
      :request-population-from="requestPopulationFrom"
      :limit="limit"
      :dark-theme="darkTheme"
      @form="updateForm"
      @input="onInput"
      @default="onDefault"
      data-vv-value-path="internalValueWithValidation"
      data-vv-validate-on="relationValidation"
      v-bind="$attrs"
      v-validate="relationValidation"
      @bcube-assistant="$emit('bcube-assistant', $event)"
    >
      <template slot="toolbar">
        <v-tooltip top>
          <v-btn slot="activator" v-if="canRequestPopulation" :disabled="disabled" icon @click="requestPopulation">
            <v-icon>flash_on</v-icon>
          </v-btn>
          <span v-html="$t('message.relation.requestPopulationFrom',
          { field: $t('message.form.fields.contentId').toLowerCase() }
          )">
          </span>
        </v-tooltip>
      </template>
    </nx-relation-editor>
  </div>
</template>

<script>
import { getTypes } from '@/modules/content/config';
import FormElement from '@/modules/form/mixins/form-element';
import CanRequestPopulation from '@/modules/form/mixins/can-request-population';
import NxRelationEditor from '@/modules/relation/editor/Editor';
import { isEmpty, isObject, isArray } from 'lodash';

export default {
  name: 'nx-relation-form',
  mixins: [FormElement, CanRequestPopulation],
  components: {
    NxRelationEditor,
  },
  props: {
    types: {
      type: Array,
      default: null,
      validator(value) {
        return !value.some(contentType => Object.keys(getTypes()).includes(contentType));
      },
    },
    value: {
      type: [Array, Object],
      default: () => [],
    },
    relationType: {
      type: String,
      default: null,
    },
    limit: {
      type: Number,
    },
    darkTheme: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: true,
    };
  },
  computed: {
    computedRelationType() {
      // If relation type is empty, use the name
      return this.relationType || this.name;
    },
    // Return an object for relation validation rule of Vee-validate.
    relationValidation() {
      const validation = {
        ...this.formatValidationObject(this.validation),
      };
      // Valid flag will be updated on updateForm callback (See below)
      validation.relation = this.valid ? 'valid' : 'invalid';
      // min/max length with the limit value
      // https://vee-vlidate.logaretm.com/v2/guide/rules.html#length
      if (this.limit > 1 && validation.length) {
        validation.length = [
          validation.length,
          this.limit,
        ];
      }
      return validation;
    },
    hasBeenValidated() {
      return this.flags.validated;
    },
  },
  watch: {
    hasBeenValidated(validated) {
      if (!validated) {
        return;
      }
      if (!this.$refs.form) {
        return;
      }
      this.$refs.form.clearErrors();
      if (!this.empty) {
        this.$refs.form.validate();
      }
    },
  },
  methods: {
    formatValidationObject(validation) {
      if (isEmpty(validation)) {
        return {};
      }
      if (isObject(validation)) {
        return validation;
      }
      if (isArray(validation)) {
        return validation
          .filter(rule => !isEmpty(rule))
          .reduce((result, rule) => {
            result[rule] = true;
            return result;
          }, {});
      }
      return { [validation]: true };
    },
    onInput(value) {
      this.$parentForm.updateField(this.name, value);
      this.$emit('input', value);
    },
    onDefault(value) {
      this.$emit('default', value);
    },
    // Update field flags when relation editor changes his state of focus and validation
    // A empty value of this field should be considered a valid value.
    async updateForm(relationEditorForm) {
      this.flags.focused = relationEditorForm.active;
      if (this.empty && this.required) {
        this.valid = false;
      } else {
        this.valid = relationEditorForm.valid || (this.empty && this.required === false);
      }
    },
  },
};
</script>
